(function () {
  'use strict';

  angular
    .module('app.lazyload', []);
})();
